import { useRef } from 'react';
import { ToggleButton } from '@mui/material';
import type { Editor } from '@tiptap/core';
import { ImageOutlined } from '@mui/icons-material';

import { useImageUploader } from '@/hooks/imageUpload';

interface Props {
  editor: Editor;
}

export const UploadImageButton = ({ editor }: Props) => {
  const fileInputRef = useRef<null | HTMLInputElement>(null);

  const upload = useImageUploader();

  // Adding image to the editor
  const addImage = (url: string) => {
    if (url) {
      editor.chain().focus().setImage({ src: url }).run();
    }
  };

  const uploadImage = async (
    evt: React.ChangeEvent<HTMLInputElement>,
    currentUpload: (file: File) => Promise<string>,
  ) => {
    const { files } = evt.target;
    const file = files && files[0];

    if (!file || !/^image\//.test(file.type)) {
      return;
    }

    try {
      //   setUploading(true);
      //   if (typeof onUploadingChange === 'function') {
      //     onUploadingChange(true);
      //   }

      const uploadedUrl = await currentUpload(file);

      addImage(uploadedUrl);
    } finally {
      //   setUploading(false);
      //   if (typeof onUploadingChange === 'function') {
      //     onUploadingChange(false);
      //   }

      if (fileInputRef?.current) {
        fileInputRef.current.value = '';
      }
    }
  };

  return (
    <>
      <ToggleButton
        value="uploadImage"
        selected={false}
        onClick={() => fileInputRef.current && fileInputRef.current.click()}
      >
        <ImageOutlined />
        <input
          accept="image/*"
          type="file"
          hidden
          onChange={(event) => {
            uploadImage(event, upload);
          }}
          ref={fileInputRef}
        />
      </ToggleButton>
    </>
  );
};
